import React, { useEffect, useState } from 'react'

const Coverage = (props) => {
    const [data, setData] = useState("")
    useEffect(() => {
     setData(props.getData())
    }, [data,props])
    const [currentIdx, setcurrentIdx] = useState("")
    
  return (
    <div className="AppointmentContainer">
    {data?.objects?.map((item, idx) => (
        <div className={`AppointmentItem ${currentIdx===idx?"active":""} cursor-pointer`} key={idx} onClick={() => {
            props.setResourceListData(item)
            setcurrentIdx(idx)
            }}>
                <span>
                    {item?.resource?.class[0].value}
                </span>
        </div>
    ))}
</div>
  )
}

export default Coverage